import { render, staticRenderFns } from "./DownPayorListModal.vue?vue&type=template&id=537944d4&"
import script from "./DownPayorListModal.vue?vue&type=script&lang=js&"
export * from "./DownPayorListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports